import "./../App.css";
import "./../AppMobile.css";

import React from "react";
import { hideProcess, setLocaleApp, showProcess } from "./../utils/util";

import { Password } from "primereact/password";
import userService from "../services/userService";

export default class ResetPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            token: "",
            newPassword: "",
            confirmPassword: "",
            loading: false,
            messagem: "",
        };
    }

    componentDidMount() {
        setLocaleApp();

        // Obter token da URL
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");

        if (!token) {
            this.setState({ messagem: "Token inválido ou ausente." });
        } else {
            this.setState({ token });
        }
    }

    handleResetPassword = async (e) => {
        e.preventDefault();

        const { token, newPassword, confirmPassword } = this.state;

        if (!newPassword || !confirmPassword) {
            alert("Por favor, preencha todos os campos.");
            return;
        }

        if (newPassword !== confirmPassword) {
            alert("As senhas não correspondem.");
            return;
        }

        if (newPassword.length < 6) {
            alert("A senha deve ter no mínimo 6 caracteres.");
            return;
        }

        try {
            showProcess();

            const response = await userService.resetPassword(token, newPassword);

            if (response.status === 200) {
                alert("Senha alterada com sucesso!");
                window.location.href = "/login";
            }
        } catch (ex) {
            if (ex.response !== undefined) {
                alert("Erro ao alterar a senha: " + ex.response.data);
            } else {
                alert("Erro ao processar sua solicitação.");
            }
        }

        hideProcess();
    };

    render() {
        const { messagem, token } = this.state;

        if (messagem) {
            return (
                <div className="app-login">
                    <div style={{backgroundColor: "var(--app-color-background)", padding: "40px", textAlign: "center"}}>
                        <img src={require("../img/Grupo10.png")} style={{width: "200px", marginBottom: "20px"}}/>
                        <h2 style={{color: "var(--app-color-primary)"}}>Erro</h2>
                        <p style={{fontSize: "16px"}}>{messagem}</p>
                        <button
                            type="button"
                            onClick={() => window.location.href = "/login"}
                            style={{
                                backgroundColor: "var(--app-color-primary)",
                                color: "#fff",
                                marginTop: "20px",
                                width: "200px",
                                border: "none",
                                borderRadius: "8px",
                                padding: "10px 20px",
                                cursor: "pointer",
                                fontSize: "16px",
                            }}
                        >
                            Voltar para Login
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className="app-login">
                <form onSubmit={(e) => this.handleResetPassword(e)} style={{backgroundColor: "var(--app-color-background)"}}>
                    <div style={{width: "100%", textAlign: "center"}}>
                        <img src={require("../img/Grupo10.png")} style={{width: "200px"}}/>
                    </div>

                    <div style={{textAlign: "center", marginTop: "25px", marginBottom: "25px"}}>
                        <h2 style={{color: "var(--app-color-primary)"}}>Redefinir Senha</h2>
                        <p>Digite sua nova senha abaixo.</p>
                    </div>

                    <div className="app-field" style={{ marginTop: "25px" }}>
                        <span>NOVA SENHA</span>
                        <Password
                            required
                            toggleMask
                            value={this.state.newPassword}
                            onChange={(e) => this.setState({ newPassword: e.target.value })}
                            feedback={false}
                        />
                    </div>

                    <div className="app-field" style={{ marginTop: "25px", marginBottom: "25px" }}>
                        <span>CONFIRMAR SENHA</span>
                        <Password
                            required
                            toggleMask
                            value={this.state.confirmPassword}
                            onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                            feedback={false}
                        />
                    </div>

                    <button id="button-entrar" type="submit">
                        Alterar Senha
                    </button>

                    <button
                        type="button"
                        onClick={() => window.location.href = "/login"}
                        style={{
                            backgroundColor: "var(--app-color-primary)",
                            color: "#fff",
                            marginTop: "15%",
                            width: "100%",
                            border: "none",
                            borderRadius: "8px",
                            padding: "10px 20px",
                            cursor: "pointer",
                            marginBottom: "20px",
                            fontSize: "16px",
                        }}
                    >
                        ← Voltar
                    </button>
                </form>
            </div>
        );
    }
}
